import clsx from "clsx";
import dayjs from "dayjs";
import styles from "../component.module.css";

const DayView = ({ current, onDateClick, selectedDate }) => {
  const isSelected = current.diff(selectedDate, "day") === 0;
  const isToday = current.isSame(dayjs(), "day");
  const isPast = current.isBefore(dayjs(), "day"); // Verifica se a data é passada

  return (
    <div
      id={clsx({ "selected-date": isSelected })}
      className={clsx(styles.dateDayItem, {
        [styles.selected]: isSelected,
        [styles.today]: isToday,
        [styles.past]: isPast // Aplica a classe de estilo para datas passadas
      })}
      onClick={() => !isPast && onDateClick(current)} 
    >
      <div className={styles.dayLabel}>{current.locale('pt-br').format("ddd")}</div>
      <div className={styles.dateLabel}>{current.locale('pt-br').format("D")}</div>
    </div>
  );
};

export default DayView;